"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carDetailsStyles = styles_1.makeStyles(function (_a) {
    var _b;
    var palette = _a.palette, typography = _a.typography, breakpoints = _a.breakpoints;
    return ({
        carDetailsWrapper: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
        },
        price: {
            fontWeight: 'initial',
        },
        carTitleImageContainer: {},
        financeApplicationButton: (_b = {
                borderRadius: 30,
                right: 0,
                top: 0
            },
            _b[breakpoints.down('xs')] = {
                right: '50%',
                transform: 'translateX(50%)',
            },
            _b),
    });
}, { name: 'GqlSummary_CarDetails' });
exports.default = carDetailsStyles;
